import Grid from '@anwb/poncho/components/grid';
import Typography from '@anwb/poncho/components/typography';
import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled, { DefaultThemeProps, css } from 'styled-components';

const RequestFlowStyles = () =>
	css(
		({ theme }: DefaultThemeProps) => css`
			margin-bottom: ${pxToRem(theme.spacing['400'])};
			word-break: keep-all;
		`
	);

export const RequestFlowTitle = styled(Typography)`
	${RequestFlowStyles}
`;

// We override the z-index to prevent the menu from showing through the receipt on mobile
const GridAsideStyles = ({ theme }: DefaultThemeProps) => css`
	@media (max-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		z-index: 900;
	}
`;

export const GridAsideStyled = styled(Grid.Aside).attrs({ isSticky: true })`
	${GridAsideStyles}
`;

const LeadDisclaimerStyles = () => css`
	display: flex;
	justify-content: flex-end;
`;

export const LeadDisclaimerContainer = styled.div`
	${LeadDisclaimerStyles}
`;
